var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noTask"},[_c('v-icon',{attrs:{"size":"140","color":"primary"}},[_vm._v(" mdi-information ")]),_c('div',{staticClass:"text-h5 primary--text"},[_vm._v("No New Task")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }